// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_ORGANIZATIONS = "GET_ORGANIZATIONS";
export const CREATE_ORGANIZATIONS = "CREATE_ORGANIZATIONS";
export const UPDATE_ORGANIZATIONS = "UPDATE_ORGANIZATIONS";
export const DELETE_ORGANIZATIONS = "DELETE_ORGANIZATIONS";
